import { getFirestore, doc, updateDoc, Timestamp } from "firebase/firestore";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from "../config"

const db = getFirestore(app);
const storage = getStorage();

const updateMPSBusinessProfile = async (documentId, MPS) => {
  try {
    let companyLogo = MPS?.companyLogo; // companyLogo is a File or a string
    const businessDocuments = MPS.documents || [];

    // Upload companyLogo if it's not already a URL
    if (companyLogo && !(typeof companyLogo === "string" && companyLogo.startsWith("http"))) {
      const timestamp = new Date().toISOString();
      const file = MPS.companyLogo;
      const fileName = `${file.name}_${timestamp}`;
      const logoPath = `MPS_companyLogos/${fileName}`;
      const fileRef = ref(storage, logoPath);

      // Upload file to Firebase Storage
      const uploadTaskSnapshot = await uploadBytes(fileRef, companyLogo);

      // Get the download URL
      companyLogo = await getDownloadURL(uploadTaskSnapshot.ref);
    }

    // Process businessDocuments
    const uploadedDocuments = await Promise.all(
      businessDocuments.map(async (doc, index) => {
        if (doc.file && !(typeof doc.file === "string" && doc.file.startsWith("http"))) {
          const documentPath = `businessProfiles/${documentId}/documents/${index}-${doc.fileName}`;
          const fileRef = ref(storage, documentPath);

          // Upload file to Firebase Storage
          const uploadTaskSnapshot = await uploadBytes(fileRef, doc.file);

          // Get the download URL
          const fileURL = await getDownloadURL(uploadTaskSnapshot.ref);

          return { ...doc, file: fileURL };
        }
        return doc; // Retain as-is if already a URL
      })
    );

    // Build the updated MPS business profile object
    const updatedMPSBusinessProfile = {
      ...MPS,
      companyLogo: companyLogo,
      documents: uploadedDocuments,
      updatedAt: Timestamp.now(),
    };

    // Reference the document to update
    const docRef = doc(db, "MPS_BusinessProfiles", documentId);

    // Update the document in Firestore
    await updateDoc(docRef, updatedMPSBusinessProfile);

    console.log("Document updated with ID: ", documentId);
    return { success: true, message: `Document updated with ID: ${documentId}` };
  } catch (error) {
    console.error("Error updating document: ", error);
    return { success: false, message: `Error updating document: ${error.message}` };
  }
};


export { updateMPSBusinessProfile };
